import * as React from 'react';
import swal from 'sweetalert';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { useDispatch } from "react-redux";
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { deleteRole } from '../api/roleapi';


const columns = [
  { id: 'name', label: 'Role Name' },
  { id: 'description', label: 'Description' },
  { id: 'role_type', label: 'Role Type' },
  //{ id: 'controller', label: 'Controller' },
  //{ id: 'created_at', label: 'Created At' },
  { id: 'actions', label: 'Actions'}
];

export default function Roles({rowsPerPage,page,handleChangePage,handleChangeRowsPerPage,roles}) {

  const dispatch = useDispatch();

  const handleDelete = (roleId) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Delete Role!",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    })
    .then(willDelete => {
      if (willDelete) {
        dispatch(deleteRole(roleId));
      }
    });
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {roles?.data?.records?.length > 0 ? roles?.data?.records.map((row,i) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                            ? column.format(value) : 
                            column.id === 'created_at' ? new Date(row?.created_at).toLocaleDateString("en-us", { year: 'numeric', month: '2-digit', day: '2-digit' })
                            : column.id === 'role_type' ? row.role_type === '1' ?  'Rehlink Sphere Portal' : 'Rehlink Mobile App'
                            : column.id === 'controller' ? row.role_type === '1' ?  '--' : 'RDCX'
                            : column.id === 'actions' ? 
                            <IconButton onClick={(e)=> handleDelete(row.id)} >
                              <DeleteIcon color="error" />
                            </IconButton>
                            : value 
                            }
                        </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
      {roles?.data?.total > 0 ?
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={roles?.data?.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage} />
        : <></>}
    </Paper>  
  );
}

